export const ANALYTICS_EVENT_TECHNICAL_IDS = {
  DYNAMIC_BANKLINE_VALUE: 'valor dinamico do bankline',
  DYNAMIC_VALUE: 'valor dinamico',
};
